import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { PaystackButton } from 'react-paystack';
import { verifyPayment } from "../../services/paymentService";

const PaystackBtn = ({ data, publicKey, onRefresh, onPaid, onClose, autoOpen, children }) => {
  const wrapperRef = useRef(null);

  const config = {
    reference: data.transid,
    email: data.email,
    amount: data.amount * 100, // Amount in kobo
    publicKey: publicKey,
  };

  if (data.subaccountCode) {
    config.subaccount = data.subaccountCode;
    if (data.splitType === 'flat' && data.splitAmount) {
      const platformShare = Math.max(0, data.amount - data.splitAmount);
      config.transaction_charge = platformShare * 100;
    }
  }

  const handlePaystackSuccessAction = async (reference) => {
    if (onPaid) {
      await onPaid(reference.reference || reference);
      return;
    }
    const response = await verifyPayment(reference);
    if (response.data.verified === true) {
      toast.success("Transaction successful!");
      if (onRefresh) onRefresh(reference.reference);
    } else {
      toast.error("Could not verify transaction!");
    }
  };

  const handlePaystackCloseAction = () => {
    toast.info("Transaction closed!");
    if (onClose) onClose();
  };

  useEffect(() => {
    if (autoOpen && wrapperRef.current) {
      const button = wrapperRef.current.querySelector('button');
      if (button) button.click();
    }
  }, [autoOpen]);

  const label = children || ' Pay Now';
  const componentProps = {
    ...config,
    children: [<i key="1" className="fa fa-credit-card" aria-hidden="true" />, label],
    className: 'btn btn-primary btn-sm',
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
  };

  return (
    <span ref={wrapperRef}>
      <PaystackButton {...componentProps} />
    </span>
  );
};

export default PaystackBtn;
